import './pdf.css';
import PdfHeader from './PdfHeader';
import PdfInfoUtil from './PdfInfoUtil';
import PdfDeudores from './PdfDeudores';
import PdfResumen from './PdfResumen';
import PdfDetalleGastos from './PdfDetalleGastos';
import PdfExpensas from './PdfExpensas';

const formatPeriodo = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return d.toLocaleDateString('es-AR', { month: 'long', year: 'numeric' });
};

const ReportePDF = ({ periodo, vencimiento, cuenta, juicios, pdfData }) => {
    return (
        <div>
            {/* ── Página 1: Info útil ── */}
            <div className="pdf-page">
                <PdfHeader />
                <hr className="pdf-divider" />

                <div className="pdf-title-box">
                    Liquidacion de Expensas del Periodo {formatPeriodo(periodo)}
                </div>

                <PdfInfoUtil
                    vencimiento={vencimiento}
                    cuenta={cuenta}
                    juicios={juicios}
                />

            </div>

            {/* ── Página 2: Deudores + Resumen ── */}
            <div className="pdf-page">
                <PdfHeader />
                <hr className="pdf-divider" />

                <div className="pdf-title-box">
                    Liquidacion de Expensas del Periodo {formatPeriodo(periodo)}
                </div>

                <PdfDeudores deudores={pdfData?.deudores || []} />

                <PdfResumen resumen={pdfData?.resumen || []} periodo={periodo} />

            </div>

            {/* ── Página 3: Detalle de Gastos ── */}
            <div className="pdf-page">
                <PdfHeader />
                <hr className="pdf-divider" />

                <div className="pdf-title-box">
                    Liquidacion de Expensas del Periodo {formatPeriodo(periodo)}
                </div>

                {pdfData?.graficoPorGrupoImg && (
                    <div style={{ textAlign: 'center', margin: '10px 0 16px' }}>
                        <div style={{ fontSize: '9pt', fontWeight: 'bold', color: '#1a3c5e', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                            Distribución de Gastos por Grupo
                        </div>
                        <img
                            src={pdfData.graficoPorGrupoImg}
                            alt="Gastos por grupo"
                            style={{ maxWidth: '340px', width: '100%', display: 'inline-block' }}
                        />
                    </div>
                )}

                <PdfDetalleGastos gastos={pdfData?.detalleGastos || []} periodo={periodo} />

            </div>

            {/* ── Página 4: Distribución de gastos y Saldos a pagar ── */}
            <div className="pdf-page">
                <PdfHeader />
                <hr className="pdf-divider" />

                <div className="pdf-title-box">
                    Liquidacion de Expensas del Periodo {formatPeriodo(periodo)}
                </div>

                <PdfExpensas expensas={pdfData?.expensas || []} periodo={periodo} />

            </div>
        </div>
    );
};

export default ReportePDF;
